import { makeStyles } from '@material-ui/core'
import {
  FormControl,
  MenuItem,
  Pagination,
  Select,
  Tooltip,
} from '@mui/material'
import {
  CUSTOM_PAGINATION_TITLE,
  PAGINATION_ROWS,
} from 'src/utils/constants/common'
import { COLORS } from 'src/utils/Themes/colors'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const CustomPagination = ({
  totalCount,
  totalLabel,
  page,
  onPageChange,
  rowsPerPage,
  onRowsPerPageChange,
}) => {
  const classes = useStyles()

  const getTotalPages = () => {
    let totalPages = Math.floor(totalCount / rowsPerPage)
    if (totalCount % rowsPerPage > 0) {
      totalPages += 1
    }
    return totalPages
  }

  return (
    <div className={classes.container}>
      {totalLabel && (
        <div className={classes.totalCountContainer}>
          <span>{totalLabel} :&nbsp;</span>
          <span className={classes.totalCount}>{totalCount}</span> &nbsp;
          <Tooltip
            title={CUSTOM_PAGINATION_TITLE}
            className={classes.descriptionIcon}
          >
            <InfoOutlinedIcon className={classes.infoIcon} />
          </Tooltip>
        </div>
      )}
      <div className={classes.paginationContainer}>
        <div className={classes.formControlRow}>
          <div className={classes.formLabel}>
            <span>Rows Per Page: </span>
          </div>
          <div className={classes.formControl}>
            <FormControl className={classes.formControlStyles} size='small'>
              <Select
                id='rowsPerPage'
                value={rowsPerPage}
                onChange={(event) => onRowsPerPageChange(event?.target?.value)}
                className={classes.selectField}
              >
                {PAGINATION_ROWS?.map((row) => (
                  <MenuItem
                    value={row?.value}
                    key={`paginationRow__${row?.label}`}
                  >
                    {row?.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <Pagination
          count={getTotalPages()}
          page={page}
          onChange={(event, newPage) => onPageChange(newPage)}
          shape='rounded'
          id='pagination'
        />
      </div>
    </div>
  )
}

export default CustomPagination

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0',
  },
  paginationContainer: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  formControlRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '5px',
    alignItems: 'center',
  },
  formLabel: {
    flex: '1 1 50%',
    display: 'flex',
    justifyContent: 'right',
    paddingRight: '10px',
  },
  formControl: {
    flex: '1 1 50%',
    width: '100%',
  },
  totalCountContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  selectField: {
    '& .MuiInputBase-input': {
      borderRadius: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  totalCount: {
    fontSize: '20px',
    color: COLORS.DARK_PINK,
    fontWeight: 'bold',
  },

  descriptionIcon: {
    color: '#b3b3b3',
    fontSize: '20px',
    textAlign: 'center',
  },
  formControlStyles: {
    minWidth: 120,
    margin: 1,
  },
})
